export const getDashboardDrawerConfig = ({
  pathname,
  isAdmin = false,
  userPlanData,
  agentPlanData,
}: {
  pathname: string;
  isAdmin: boolean;
  userPlanData: string;
  agentPlanData: string;
}) => {
  const isPathActive = (path: string) => pathname === path;
  const freeTrialPlan = userPlanData === 'freeTrialAccess' || agentPlanData === 'agentTrialPlan';
  const noActivePlan = userPlanData === 'noActivePlan' && agentPlanData === 'noAgentPlan';
  const noAgentPlan = agentPlanData === 'noAgentPlan' || agentPlanData === 'agentTrialPlan';

  return [
    {
      id: 'dashboard',
      label: 'Dashboard',
      iconPath: isPathActive('/dashboard')
        ? '/assets/icons/dashboard.svg'
        : '/assets/icons/dashboard_default.svg',
      link: '/dashboard',
      isActive: isPathActive('/dashboard'),
      subLinks: [],
    },
    {
      id: 'agent',
      label: 'Everything Agent',
      iconPath: isPathActive('/ai-studio')
        ? '/assets/icons/EverythingAgent.svg'
        : '/assets/icons/EverythingAgent_default.svg',
      link: '/ai-studio',
      isActive: isPathActive('/ai-studio'),
      subLinks: [],
      isLocked:
        (freeTrialPlan || noActivePlan || noAgentPlan) && agentPlanData !== 'agentTrialPlan'
          ? true
          : false,
    },
    isAdmin && {
      id: 'admin',
      label: 'Admin',
      iconPath: [
        '/admin',
        '/user-management',
        '/affiliate-management',
        '/admin/subscription-management',
        '/admin/ai-models',
      ].includes(pathname)
        ? '/assets/icons/admin.svg'
        : '/assets/icons/admin_default.svg',
      isActive: [
        '/admin',
        '/user-management',
        '/affiliate-management',
        '/admin/subscription-management',
        '/admin/ai-models',
      ].includes(pathname),
      subLinks: [
        {
          id: 'add-credits',
          label: 'Add Credits',
          link: '/admin',
          isActive: isPathActive('/admin'),
        },
        {
          id: 'user-management',
          label: 'User Management',
          link: '/user-management',
          isActive: isPathActive('/user-management'),
        },
        {
          id: 'subscription-management',
          label: 'Subscription Management',
          link: '/admin/subscription-management',
          isActive: isPathActive('/admin/subscription-management'),
        },
        {
          id: 'affiliate-management',
          label: 'Affiliate Management',
          link: '/affiliate-management',
          isActive: isPathActive('/affiliate-management'),
        },
        {
          id: 'AI Model Management',
          label: 'AI Model Management',
          link: '/admin/ai-models',
          isActive: isPathActive('/admin/ai-models'),
        },
      ],
    },
    {
      id: 'ai-create',
      label: 'AI Create',
      iconPath: [
        '/broll',
        '/talking-face',
        '/text-to-image',
        '/text-to-audio',
        '/ai-text',
        '/music',
      ].includes(pathname)
        ? '/assets/icons/create-video.svg'
        : '/assets/icons/create-video_default.svg',
      isActive: [
        '/broll',
        '/talking-face',
        '/text-to-image',
        '/text-to-audio',
        '/ai-text',
        '/music',
      ].includes(pathname),
      subLinks: [
        {
          id: 'create-broll',
          label: 'AI Video (New)',
          link: '/broll',
          isActive: isPathActive('/broll'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
        {
          id: 'talking-face',
          label: 'Lip Sync',
          link: '/talking-face',
          isActive: isPathActive('/talking-face'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
        {
          id: 'create-image',
          label: 'Image',
          link: '/text-to-image',
          isActive: isPathActive('/text-to-image'),
          isLocked: noActivePlan ? true : false,
        },
        {
          id: 'create-audio-voiceover',
          label: 'Audio-Voiceover',
          link: '/text-to-audio',
          isActive: isPathActive('/text-to-audio'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },

        {
          id: 'music',
          label: 'Audio-Music',
          link: '/music',
          isActive: isPathActive('/music'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
        {
          id: 'create-ai-text',
          label: 'Chatbot',
          link: '/ai-text',
          isActive: isPathActive('/ai-text'),
          isLocked: noActivePlan ? true : false,
        },
      ],
    },
    {
      id: 'labs',
      label: 'Labs',
      iconPath: ['/voice-studio', '/clipdeck', '/upscale', '/ai-clipper'].includes(pathname)
        ? '/assets/icons/labs.svg'
        : '/assets/icons/labs_default.svg',
      isActive: ['/voice-studio', '/clipdeck', '/upscale', '/ai-clipper'].includes(pathname),
      subLinks: [
        // {
        //   id: 'ai-studio',
        //   label: 'AI Studio (New)',
        //   link: '/ai-studio',
        //   isActive: isPathActive('/ai-studio'),
        //   isLocked: freeTrialPlan || noActivePlan ? true : false,
        // },
        {
          id: 'ai-clipper',
          label: 'AI Clipper (New)',
          link: '/ai-clipper',
          isActive: isPathActive('/ai-clipper'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
        {
          id: 'voice-studio',
          label: 'Voice Studio',
          link: '/voice-studio',
          isActive: isPathActive('/voice-studio'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
        {
          id: 'clipdeck',
          label: 'Timeline Editor (New)',
          link: '/clipdeck',
          isActive: isPathActive('/clipdeck'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
        {
          id: 'upscale',
          label: 'Upscale',
          link: '/upscale',
          isActive: isPathActive('/upscale'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
      ],
    },
    {
      id: 'ai-optimize',
      label: 'AI Optimize',
      iconPath: ['/broll-caption'].includes(pathname)
        ? '/assets/icons/ai-optimize.svg'
        : '/assets/icons/ai-optimize_default.svg',
      isActive: pathname === '/broll-caption',
      subLinks: [
        {
          id: 'optimize-broll',
          label: 'Captions & Effects',
          link: '/broll-caption',
          isActive: isPathActive('/broll-caption'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
      ],
    },
    {
      id: 'ai-avatars',
      label: 'AI Avatars',
      iconPath: ['/create-video', '/cloned-audios', '/created-avatar'].includes(pathname)
        ? '/assets/icons/created-avatar.svg'
        : '/assets/icons/created-avatar_default.svg',
      isActive: ['/create-video', '/cloned-audios', '/created-avatar'].includes(pathname),
      subLinks: [
        {
          id: 'avatars-video',
          label: 'Create Video',
          link: '/create-video',
          isActive: isPathActive('/create-video'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
        {
          id: 'avatars-audio',
          label: 'Create Audio',
          link: '/cloned-audios',
          isActive: isPathActive('/cloned-audios'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
        {
          id: 'create-talking-face',
          label: 'Create Avatar',
          link: '/created-avatar',
          isActive: isPathActive('/created-avatar'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
      ],
    },
    {
      id: 'ai-media',
      label: 'Media',
      iconPath: ['/your-videos', '/your-audios'].includes(pathname)
        ? '/assets/icons/your-videos.svg'
        : '/assets/icons/your-videos_default.svg',
      isActive: ['/your-videos', '/your-audios'].includes(pathname),
      subLinks: [
        {
          id: 'ai-videos',
          label: 'Videos',
          link: '/your-videos',
          isActive: isPathActive('/your-videos'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
        {
          id: 'media-images',
          label: 'Images',
          link: '/your-images',
          isActive: isPathActive('/your-images'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
        {
          id: 'media-audios',
          label: 'Audios',
          link: '/your-audios',
          isActive: isPathActive('/your-audios'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
        {
          id: 'media-texts',
          label: 'Texts',
          link: '/your-texts',
          isActive: isPathActive('/your-texts'),
          isLocked: freeTrialPlan || noActivePlan ? true : false,
        },
      ],
    },
  ].filter(Boolean);
};
